

// Import ----------------------------------------------------------------------

// Project
import { ContentNode, ContentImageMeta, VueGlobalInjectable } from "~/libs/Types";

// Export ----------------------------------------------------------------------

export default VueGlobalInjectable.extend({

    // Component Properties ----------------------------------------------------

    props: {
        node: {
            type: Object as () => ContentNode,
            required: true
        }
    },

    // Component Attribute, Properties & Injected ------------------------------

    computed: {
        imageSrc (): string {
            return this.node.image ?? "";
        },

        imageLink (): string {
            return this.node.path;
        },

        mediaMeta (): ContentImageMeta {
            const meta =  new ContentImageMeta();

            meta.title = this.node.title;
            meta.alt = this.node.metaData.description;

            return meta;
        }
    }

    // -------------------------------------------------------------------------
});
